import React, { FC } from "react";
import { StepTab } from "./StepTab";
import { IStep } from "../types";

interface Props {
  stepItems: IStep[];
  activeStepIndex: number;
  setActiveStepIndex: React.Dispatch<React.SetStateAction<number>>;
}

export const Stepper: FC<Props> = ({
  stepItems,
  activeStepIndex,
  setActiveStepIndex,
}) => {
  const onClick = (index: number) => () => setActiveStepIndex(index);

  return (
    <div className="hidden lg:flex items-center gap-2 xl:gap-4">
      {stepItems.map((step, i) => (
        <StepTab
          key={step.id}
          step={step}
          isActive={i === activeStepIndex}
          onClick={onClick(i)}
        />
      ))}
    </div>
  );
};
